import AccessPointShippingForm from './AccessPoint';
export default class CorreosExpressShippingForm extends AccessPointShippingForm {
    init() {
        super.init();
        this.settings = {};
        this.initConfig(this.settings);
    }

    findPickUpLocations (shippingMethodId) {
        var $locatorForm = this.locatorForm.$el;
        var address = $locatorForm.find('.js-get-address-suggestions').val();
        var zipCode = $locatorForm.find('.js-get-zipcode-suggestions').val();
        var formData = $locatorForm.serializeArray();
        var action = $locatorForm.find('.js-find-location').attr('name');
        if (!address && !zipCode) {
            return;
        }
        this.handleGetLocationsPicker(action, formData, null, shippingMethodId);
    }
}